// https://wiki.jtiweb.co.uk/display/DIGITECH/Date+format
import dayjs from "dayjs";
import debug from "debug";
import { getConfig, getLocale } from "@jti/fe-common";
import { normalizeDate } from "./normalizeDate";
const log = debug("desjti:ui:formatDate");
const translateMonths = ({ date, format, locale }) => {
    const monthLong = date.toLocaleString(locale, { month: "long" });
    const monthShort = date.toLocaleString(locale, { month: "short" });
    const longMonthRegex = /MMMM(?![^[]*])/g; // Matches MMMM if it's not surrounded by square brackets []
    const shortMonthRegex = /MMM(?![^[]*])/g; // Matches MMM if it's not surrounded by square brackets []
    format = format.replace(longMonthRegex, `[${monthLong}]`); // Add square brackets to ensure dayjs ignores it
    format = format.replace(shortMonthRegex, `[${monthShort}]`);
    return format;
};
export const formatDate = (date, format, serverSideLocale) => {
    if (!date) {
        return "";
    }
    const config = getConfig();
    const locale = serverSideLocale || getLocale();
    const customFormat = format || config?.dateFormat;
    const dateObject = normalizeDate(date);
    if (dateObject instanceof Date && isNaN(dateObject.getTime())) {
        if (typeof date === "string") {
            return date;
        }
        return "";
    }
    log("formatDate", {
        valueObtained: date,
        normalizedValue: dateObject,
        customFormat,
        locale,
        timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
    });
    if (!customFormat) {
        return Intl.DateTimeFormat(locale).format(dateObject);
    }
    const formatWithTranslatedMonths = translateMonths({ date: dateObject, format: customFormat, locale });
    return dayjs(dateObject).locale(locale).format(formatWithTranslatedMonths).replace(/\s+/g, " ");
};
//# sourceMappingURL=formatDate.js.map